import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=2bf4d4c5&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports